// extracted by mini-css-extract-plugin
export default {"step":"frequencyAndDuration_step__u50kq","stepCompleted":"frequencyAndDuration_stepCompleted__pQ-xz"};